import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { RobotoIconButton } from "@/shared/components/RobotoIconButton";
import { RobotoTooltip } from "@/shared/components/RobotoTooltip";
import { usePopupState } from "@/shared/hooks";

import { FilePicker } from "../../FilePicker";
import { useActiveDatasetIds } from "../hooks/useActiveDatasetIds";
import { useAddFilesToWorkspace } from "../hooks/useAddFilesToWorkspace";
import { useEphemeralWorkspaceState } from "../WorkspaceCtx/hooks";

export function AddFilesButton() {
  const orgId = useCurrentOrgId();
  const popup = usePopupState();
  const { addFiles } = useAddFilesToWorkspace();
  const { files } = useEphemeralWorkspaceState();
  const activeDatasetIds = useActiveDatasetIds();

  const handleSubmit = (selectedFileIds: string[]) => {
    addFiles(selectedFileIds);
    popup.close();
  };

  return (
    <>
      <RobotoTooltip title="Add files to workspace">
        <span>
          <RobotoIconButton
            onClick={() => popup.open()}
            eventName={"AddFilesToWorkspaceClicked"}
            sx={{ padding: "0.5rem" }}
          >
            <NoteAddOutlinedIcon fontSize="small" />
          </RobotoIconButton>
        </span>
      </RobotoTooltip>
      <FilePicker
        orgId={orgId}
        open={popup.isOpen}
        onClose={popup.close}
        onSubmit={(files) => handleSubmit(files.map((f) => f.file_id))}
        title="Add files to workspace"
        activeDatasetIds={activeDatasetIds}
        existingFileIds={files.map((file) => file.file_id)}
      />
    </>
  );
}
